export enum FireState {
  // default
  None = 'None',

  // based on queue state
  Busy = 'Busy',
  OfflineMachine = 'OfflineMachine',
  OfflineUser = 'OfflineUser',

  // based on ball count in machine
  DropBall = 'DropBall',
  BallError = 'BallError',

  // based on requiresSend
  LoadPitch = 'LoadPitch',

  // based on loadingUntil
  Loading = 'Loading',

  // based on r2f
  NotReadyToFire = 'NotReadyToFire',
  ReadyToAutoFire = 'ReadyToAutoFire',
  ReadyToManualFire = 'ReadyToManualFire',

  // based on fire response
  AwaitingFR = 'AwaitingFR',

  // based on training response, only while training
  AwaitingTR = 'AwaitingTR',
  // somehow a pitch is not trained during BP, should look like not R2F (e.g. matching shots are still loading)
  UntrainedBP = 'UntrainedBP',

  // on-demand status says it cannot be used w/o firing calibration shots first
  UncalibratedOD = 'UncalibratedOD',

  Firing = 'Firing',

  // while context is suspended
  Paused = 'Paused',
}

export enum IgnoreAutoFireMode {
  Disabled = 'Disabled', // i.e. not ignoring AF
  Temporary = 'Temporary', // goes to Disabled when a temporary condition is lifted
  Permanent = 'Permanent', // can only be cleared by receiving a successful fire response
}
